"use client"

import { useEffect, useRef } from "react"
import { usePathname } from "next/navigation"
import { BarsThree, XMark, ArrowRight } from "@medusajs/icons"
import Link from "@modules/common/components/localized-client-link"
import EquipmentSearch from "@modules/search/components/equipment-search"

export function EquipmentMobileMenu({
  links,
  brandName,
}: {
  links: { href: string; label: string }[]
  brandName: string
}) {
  const dialog = useRef<HTMLDialogElement>(null)
  useEffect(() => {
    const desktop = window.matchMedia("(min-width: 1000px)")
    const closeOnDesktop = () => {
      if (desktop.matches) dialog.current?.close()
    }
    desktop.addEventListener("change", closeOnDesktop)
    return () => desktop.removeEventListener("change", closeOnDesktop)
  }, [])
  return (
    <div className="equipment-mobile-menu">
      <button
        type="button"
        className="equipment-icon-button"
        aria-label="Abrir menú"
        aria-haspopup="dialog"
        onClick={() => dialog.current?.showModal()}
      >
        <BarsThree aria-hidden="true" />
      </button>
      <dialog
        ref={dialog}
        className="equipment-menu-dialog"
        aria-labelledby="equipment-menu-title"
        onClick={(event) => {
          if (event.target === event.currentTarget) dialog.current?.close()
        }}
      >
        <div className="equipment-menu-content">
          <div className="equipment-menu-heading">
            <h2 id="equipment-menu-title">Tu hogar comienza aquí.</h2>
            <button
              type="button"
              className="equipment-icon-button"
              aria-label="Cerrar menú"
              onClick={() => dialog.current?.close()}
            >
              <XMark aria-hidden="true" />
            </button>
          </div>
          <nav aria-label={`Explorar ${brandName}`}>
            {links.map(({ href, label }) => (
              <Link
                key={href}
                href={href}
                onClick={() => dialog.current?.close()}
              >
                {label}
                <ArrowRight aria-hidden="true" />
              </Link>
            ))}
          </nav>
          <div className="equipment-menu-help">
            <p>Te acompañamos en cada paso.</p>
            <Link href="/seguimiento" onClick={() => dialog.current?.close()}>
              Seguir mi compra
            </Link>
            <Link href="/account" onClick={() => dialog.current?.close()}>
              Mi cuenta
            </Link>
            <Link href="/ayuda" onClick={() => dialog.current?.close()}>
              Ayuda y contacto
            </Link>
          </div>
        </div>
      </dialog>
    </div>
  )
}

export function EquipmentMobileSearch() {
  const pathname = usePathname()
  if (!/^\/[a-z]{2}\/?$/.test(pathname) && !pathname.endsWith("/store"))
    return null
  return (
    <div className="equipment-mobile-search">
      <EquipmentSearch compact />
    </div>
  )
}
